// src/components/RouteModal/RouteInfoModal.jsx
import React, { useState, useEffect } from 'react';
import api from '../../../../services/api';
import styles from './RouteInfoModal.module.css';

export default function RouteInfoModal({
  routeId,
  onClose,
  onSave
}) {
  const [form, setForm] = useState({
    driver: '',
    loader1: '',
    loader2: '',
    timeFrom: '08:00',
    timeTo: '18:00',
    delivery_volume: 0,
    delivery_weight: 0
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  // При монтировании – подтягиваем актуальные данные и блокируем поля
  useEffect(() => {
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await api.get(`/routes/${routeId}`);
        setForm({
          driver: data.driver || '',
          loader1: data.loader1 || '',
          loader2: data.loader2 || '',
          timeFrom: data.time_from || '08:00',
          timeTo: data.time_to || '18:00',
          delivery_volume: data.delivery_volume || 0,
          delivery_weight: data.delivery_weight || 0
        });
      } catch (e) {
        setError(e.message || 'Не удалось загрузить маршрут');
      } finally {
        setLoading(false);
      }
    })();
  }, [routeId]);

const handleChange = e => {
  const { name, value, type } = e.target;

  if (name === 'delivery_volume') {
    // 1) Оставляем только цифры
    let str = value.replace(/\D/g, '');
    // 2) Убираем все ведущие нули, но только если после них есть цифры
    str = str.replace(/^0+(?=\d)/, '');
    // 3) Если получилось пусто, показываем один "0"
    if (str === '') str = '0';

    const vol = Number(str);
    setForm(f => ({
      ...f,
      delivery_volume: str,
      delivery_weight: vol * 19
    }));
    return;
  }

  // остальная логика для других полей
  const val = type === 'number' ? Number(value) : value;
  setForm(f => ({ ...f, [name]: val }));
};


  const handleSave = async () => {
    setSaving(true);
    setError(null);
    try {
      const payload = {
        driver: form.driver,
        loader1: form.loader1,
        loader2: form.loader2,
        time_from: form.timeFrom,
        time_to: form.timeTo,
        delivery_volume: form.delivery_volume,
        delivery_weight: form.delivery_weight
      };
      const updated = await api.patch(`/routes/${routeId}`, payload);
      onSave(updated);
      onClose();
    } catch (e) {
      setError(e.response?.data?.message || e.message || 'Ошибка сохранения');
    } finally {
      setSaving(false);
    }
  };

  // Все поля блокируются, когда loading или saving
  const disabled = loading || saving;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <header className={styles.header}>
          <h2>Редактировать маршрут</h2>
          <button onClick={onClose} disabled={disabled}>✕</button>
        </header>

        <div className={styles.body}>
          {error && <div className={styles.error}>{error}</div>}

          <label>
            Водитель
            <input
              name="driver"
              value={form.driver}
              onChange={handleChange}
              disabled={disabled}
            />
          </label>

          <label>
            Грузчик 1
            <input
              name="loader1"
              value={form.loader1}
              onChange={handleChange}
              disabled={disabled}
            />
          </label>

          <label>
            Грузчик 2
            <input
              name="loader2"
              value={form.loader2}
              onChange={handleChange}
              disabled={disabled}
            />
          </label>

          <label>
            Время от
            <input
              type="time"
              name="timeFrom"
              value={form.timeFrom}
              onChange={handleChange}
              disabled={disabled}
            />
          </label>

          <label>
            Время до
            <input
              type="time"
              name="timeTo"
              value={form.timeTo}
              onChange={handleChange}
              disabled={disabled}
            />
          </label>

          <label>
            Объём доставки (шт.)
            <input
              type="number"
              name="delivery_volume"
              value={form.delivery_volume}
              placeholder="0"
              onChange={handleChange}
              onBlur={() => {
                // Если оставили пустым — восстанавливаем 0 и сбрасываем вес
                if (form.delivery_volume === '') {
                  setForm(f => ({
                    ...f,
                    delivery_volume: '0',
                    delivery_weight: 0
                  }));
                }
              }}
              disabled={disabled}
            />
          </label>


          <label>
            Вес доставки (кг)
            <input
              type="number"
              name="delivery_weight"
              value={form.delivery_weight}
              readOnly
            />
          </label>
        </div>

        <footer className={styles.footer}>
          <button onClick={onClose} disabled={disabled}>Отмена</button>
          <button onClick={handleSave} disabled={disabled}>
            {saving ? 'Сохраняем...' : 'Сохранить'}
          </button>
        </footer>
      </div>
    </div>
  );
}
